module.exports = __webpack_public_path__ + "assets/img/assignment_icon.svg";